module.exports = __webpack_public_path__ + "newmessages.png?972e9a3feb5193f045dee94f9fd6c838";